export const SIDE_MENU_STORAGE_KEY = 'side-menu'
export const SIDE_MENU_COLLAPSE_VALUE = 'true'
